export default "__VITE_ASSET__Dlop2mPR__"